
<div class="flex-1 h-full flex flex-col min-h-0">
  <!-- Header -->
  <div class="mt-2 h-10 shrink-0 flex flex-col justify-center mb-3 md:mb-6">
    <h1 class="headline-medium text-primary" data-testid="settings-page-title">{{ 'Settings' | translate }}</h1>
  </div>

  <!-- Redesigned Tabs (Figma) -->
  <div class="bg-surface-container-lowest rounded-lg border border-linear-stroke grow flex flex-col gap-4 min-h-0 tab-start">
    <mat-tab-group
      [animationDuration]="'0ms'"
      class="!bg-surface-container-low"
      mat-stretch-tabs="false"
      [selectedIndex]="selectedIndex"
      (selectedTabChange)="onTabChange($event)">
      <ng-container *ngFor="let tab of tabs">
        <mat-tab>
          <ng-template mat-tab-label>
            <span>{{ tab.label | translate }}</span>
          </ng-template>
        </mat-tab>
      </ng-container>
    </mat-tab-group>

    <!-- Tab Content -->
    <div #tabContent class="px-2 pt-2 md:px-4 md:pt-4 overflow-y-auto flex-1 min-h-0">
      <ng-container *ngIf="activeTab === 'my-details'">
        <app-settings-details></app-settings-details>
      </ng-container>

      <ng-container *ngIf="activeTab === 'security'">
        <app-settings-security></app-settings-security>
      </ng-container>

      <ng-container *ngIf="activeTab === 'templates'">
        <app-settings-templates></app-settings-templates>
      </ng-container>
    </div>
  </div>
</div>
